import React from 'react';


interface Props {
  onScroll: (minContentOffsetY: number, maxContentOffsetY: number) => void;
  children: JSX.Element;
}

export const PageScrollListener = ({ onScroll, children }: Props) => {
  React.useEffect(() => {
    const listener = () => {
      onScroll(window.scrollY, window.scrollY + window.innerHeight);
    };
    window.addEventListener('scroll', listener);

    // Broadcast the scroll on first mount.
    listener();

    return () => window.removeEventListener('scroll', listener);
  }, [onScroll]);

  return children;
};

export default PageScrollListener;
